'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropDown;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function DropDown(_ref) {
  let {
    buttonLabel,
    buttonAriaLabel,
    buttonClassName,
    buttonIconClassName,
    children
  } = _ref;
  const dropDownRef = (0, _react.useRef)(null);
  const buttonRef = (0, _react.useRef)(null);
  const [showDropDown, setShowDropDown] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const button = buttonRef.current;
    const dropDown = dropDownRef.current;
    if (showDropDown && button !== null && dropDown !== null) {
      const {
        top,
        left
      } = button.getBoundingClientRect();
      dropDown.style.top = top + 40 + 'px';
      dropDown.style.left = Math.min(left, window.innerWidth - dropDown.offsetWidth - 20) + 'px';
      dropDown.style.opacity = '1';
    }
  }, [dropDownRef, buttonRef, showDropDown]);
  (0, _react.useEffect)(() => {
    const button = buttonRef.current;
    if (button !== null && showDropDown) {
      const handle = event => {
        const target = event.target;
        if (!button.contains(target)) {
          setShowDropDown(false);
        }
      };
      document.addEventListener('click', handle);
      return () => document.removeEventListener('click', handle);
    }
  }, [dropDownRef, buttonRef, showDropDown]);
  const output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    "aria-label": buttonAriaLabel || buttonLabel,
    className: buttonClassName,
    onClick: () => setShowDropDown(!showDropDown),
    ref: buttonRef
  }, buttonIconClassName ? /*#__PURE__*/_react.default.createElement("span", {
    className: buttonIconClassName
  }) : undefined, buttonLabel ? /*#__PURE__*/_react.default.createElement("span", {
    className: "text dropdown-button-text"
  }, buttonLabel) : undefined, /*#__PURE__*/_react.default.createElement("i", {
    className: "chevron-down"
  })), showDropDown ? /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown c-text-editor__dropdown",
    ref: dropDownRef
  }, children), document.body) : undefined);
  return output;
}
